import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';

import { FormattedMessageWrappedInSpan, FormattedPrice } from '../../misc';
import { trackEvent } from '../../../utils/ga-tracking';

import { useLocation } from 'react-router-dom';

const FotoFlatOffer = (props) => {
  const {
    onScrollToImpressions,
    onScrollToVoucher,
    onScrollToVideo,
    onScrollToCertificate,
    offer,
    participantMediaCount,
    impressionMediaCount,
    onBuyFotoFlatClick,
    setFotoFlatRef,
    hasVideo,
    hasVideoUrl,
    hasCertificates,
  } = props;
  // all 'icon eyes' and scrollToImpression won't work in dual search page if we want to show an offer in this view
  //const isDualSearchPage = useLocation().pathname.includes('dual');

  const scrollToImpressions = (event) => {
    event.stopPropagation();
    onScrollToImpressions();
  };

  const scrollToVoucher = (event) => {
    event.stopPropagation();
    onScrollToVoucher();
  };

  const scrollToVideo = (event) => {
    event.stopPropagation();
    onScrollToVideo();
  };

  const scrollToCertificate = (event) => {
    event.stopPropagation();
    onScrollToCertificate();
  };

  const fotoFlatRef = useRef(null);

  useEffect(() => {
    if (setFotoFlatRef) {
      setFotoFlatRef(fotoFlatRef);
    }
  }, []);

  return (
    <div
      className="fotoflat-offer-container pricelist-container medialist-item-container"
      ref={fotoFlatRef}
    >
      <div className="pricelist">
        <div className="pricelist-header">
          <FormattedMessageWrappedInSpan
            id="global.fotoFlat"
            defaultMessage="Foto-Flat"
          />
        </div>
        <div className="pricelist-body">
          <div className="pricelist-item pricelist-item-fotoflat">
            <FormattedMessageWrappedInSpan
              id="fotoFlatOffer.personalPhotos"
              defaultMessage="All {count} personal digital fotos (JPG)"
              values={{ count: participantMediaCount > 0 ? participantMediaCount : '' }}
            />
          </div>
          {impressionMediaCount > 0 && (
            <div
              className="pricelist-item pricelist-item-impressions"
              onClick={scrollToImpressions}
            >
              <FormattedMessageWrappedInSpan
                id="fotoFlatOffer.impressionPhotos"
                defaultMessage="All {count} digital impressions (JPG)"
                values={{ count: impressionMediaCount }}
              />
              <span className="icon eye" />
            </div>
          )}
          {hasVideo && (
            <div
              className="pricelist-item pricelist-item-video"
              onClick={(event) => {
                if (hasVideoUrl ) {
                  scrollToVideo(event);
                }
              }}
            >
              <FormattedMessageWrappedInSpan
                id="fotoFlatOffer.videoOffert"
                defaultMessage="Personalized video (MP4)"
              />
              {hasVideoUrl  && <span className="icon eye" />}
            </div>
          )}
          {hasCertificates && (
            <div className="pricelist-item" onClick={scrollToCertificate}>
              <FormattedMessageWrappedInSpan
                id="fotoFlatOffer.certificatesOffert"
                defaultMessage="Printable certificate (JPG)"
              />
              <span className="icon eye" />
            </div>
          )}
          {offer.voucher && (
            <div
              className="pricelist-item pricelist-item-voucher"
              onClick={scrollToVoucher}
            >
              <div
                dangerouslySetInnerHTML={{
                  __html: offer.voucher.shortText,
                }}
              />
             <span className="icon eye" />
            </div>
          )}
          <div className="main-price">
            <FormattedPrice price={offer.price} />
          </div>
        </div>
        <div
          className="pricelist-main-price "
          onClick={() => {
            trackEvent('Event', 'Buy', 'Foto-Flat banner');
            onBuyFotoFlatClick();
          }}
        >
          <div className="pricelist-call-to-action pulsate-animation">
            <FormattedMessageWrappedInSpan
              id="fotoFlatOffer.buyButton"
              defaultMessage="Buy now"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

FotoFlatOffer.propTypes = {
  participantMediaCount: PropTypes.number,
  impressionMediaCount: PropTypes.number,
  offer: PropTypes.shape({
    id: PropTypes.string,
    price: PropTypes.object,
    voucher: PropTypes.object,
  }),
  onBuyFotoFlatClick: PropTypes.func,
  onScrollToImpressions: PropTypes.func,
  onScrollToVoucher: PropTypes.func,
  onScrollToVideo: PropTypes.func,
  onScrollToCertificate: PropTypes.func,
  animationWhenComponentIsVisible: PropTypes.func,
  setFotoFlatRef: PropTypes.func,
  hasVideo: PropTypes.bool,
  hasVideoUrl: PropTypes.bool,
  hasCertificates: PropTypes.bool,
  hasCertificateUrl: PropTypes.bool,
};

export default FotoFlatOffer;
